import { createHistory } from "../../api/historyService";

export const useCreateHistory = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createHistory(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create history", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};